import React from 'react';
import {
  FDBanner, FDBannerText,
  FDBox,
  FDContentContainer, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { BackButton } from 'Views/FreemiumEntry/HasRelationship/Content/Components/BackButton';
import TopNav from 'Components/ClientApp/CombinedApp/Navigation/TopNav';
import { FreemiumNav } from 'Views/FreemiumEntry/HasRelationship/Content/Components/FreemiumNav';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const QuizWrapperLayout = ({
  children, setLink, maxWidth = 'sm', bottomSpacing = true,
}) => {
  const isMobile = useMobileLayout();
  const { resource } = useMetaLayoutContext();

  return (
    <>
      <FDBox>
        {/* This is a bit different than the other nav bars in the app because it stays on the top of the screen in
        both mobile and desktop (the other navs have a drawer-style nav for mobile.) This works because we only have a
        single nav button -- the logo button. If we add more buttons in the freemium view we will need to re-consider this. */}
        {resource.attr('bannerText') ? (
          <FDBanner color={'primary'}>
            <FDBannerText value={resource.attr('bannerText')} />
          </FDBanner>) : null}
        <TopNav Component={FreemiumNav} />
        <FDBox paddingY={isMobile ? 2 : 0}>
          <FDContentContainer maxWidth={maxWidth}>
            <FDStack direction={'column'} spacing={4}>
              {children}
              <BackButton setLink={setLink} />
              {resource.attr('generalDisclosure') && (
                <FDBox paddingY={3} paddingX={1}>
                  <MetaControlField attr="generalDisclosure" />
                </FDBox>)}
            </FDStack>
          </FDContentContainer>
        </FDBox>
      </FDBox>
      {/* This is essentially a spacing unit so that the continue button does not cover the disclosure */}
      {bottomSpacing && <FDBox paddingY={6} />}
    </>
  );
};
